<template>
    <div @mouseover="isHovered = true"
         @mouseleave="isHovered = false"
         class="row automation-row">
        <div v-if="isHovered" v-tooltip="'Drag and drop to reorder'" class="drag-icon">
            <i class="far fa-lg fa-grip-dots-vertical"></i>
        </div>
        <div style="flex: 0 0 auto" class="align-self-center px-3">
            <AutomationCategoryIcon
                v-if="!automation.categories || automation.categories.length === 0"
                :uuid="automationCategoryCustom.uuid"
                class="px-2 font-18"/>
            <template v-else>
                <AutomationCategoryIcon
                    v-for="catId in automation.categories"
                    :key="catId"
                    :uuid="catId"
                    class="px-2 font-18"/>
            </template>
        </div>
        <div class="col align-self-center flex-column h-100">
            <AutomationSentenceDisplayValue :automation="automation" :fontSize="20"/>
        </div>
        <div class="align-self-center text-right" style="flex: 0 0 160px">
            <AppSwitch @click.native.stop
                       :value="!!automation.enabled"
                       @toggle="onAutomationToggle"
                       :disabled="isUpdating">
            </AppSwitch>
        </div>
        <div @click.stop class="align-self-center text-right" style="flex: 0 0 80px">
            <AutomationBoardItemActions
                @delete="onDeleteAutomation"
                @connection-click="onConnectionClick"/>
        </div>
    </div>
</template>

<script>
import {withConfirmation} from '@/decorators/withConfirmation'
import AutomationSentenceDisplayValue from '../../../components/automation/AutomationSentenceDisplayValue.vue'
import AutomationCategoryIcon from '../categories/AutomationCategoryIcon'
import AutomationBoardItemActions from './AutomationBoardItemActions'
import {automationsApi} from '@/api/automations'
import {showErrorMessage} from '@/services/snackbar'
import {automationCategoryCustom} from '@/types/automations/categories'
import AppSwitch from '@/components/shared/AppSwitch.vue'
import {cloneDeep} from 'lodash'

export default {
    name: 'AutomationBoardItem',
    components: {AppSwitch, AutomationBoardItemActions, AutomationCategoryIcon, AutomationSentenceDisplayValue},
    props: {
        automation: { // Automation
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isHovered: false,
            isUpdating: false,
            automationCategoryCustom
        }
    },
    methods: {
        async onAutomationToggle() {
            this.isUpdating = true
            const updatedAutomation = cloneDeep(this.automation)
            updatedAutomation.enabled = !updatedAutomation.enabled
            const {error} = await automationsApi.update({id: this.automation.uuid, data: updatedAutomation})
            if (error) {
                showErrorMessage('Failed to update automation')
            } else {
                this.$emit('change', updatedAutomation)
            }
            this.isUpdating = false
        },

        async onDeleteAutomation() {
            withConfirmation({
                title: 'Delete Automation',
                description: 'Are you sure you want to delete this automation?',
                onConfirm: this.deleteAutomation
            })
        },

        async deleteAutomation() {
            this.isDeleting = true
            const {error} = await automationsApi.delete(this.automation.uuid)
            if (error) {
                showErrorMessage('Failed to delete automation')
            } else {
                this.$emit('delete', this.automation)
            }
            this.isDeleting = false
        },

        onConnectionClick(path) {
            this.$bus.$emit('edit-automation-connection', {
                automation: this.automation,
                authParamPath: path
            })
        }
    }
}
</script>

<style scoped lang="scss">
.automation-row {
    margin: 0;
    padding: 16px 32px;
    border-radius: 4px;
    box-shadow: $box-shadow-sm;
    border: 1px solid lighten($color-grey-light, 8%);
    background-color: #ffffff;
    transition: box-shadow 0.5s;
    position: relative;

    &:hover {
        box-shadow: $box-shadow;
        cursor: pointer;
    }
}

.custom-control-label {
    padding-top: 2px;
}

.drag-icon {
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    color: $color-grey-light;
}
</style>
